module.exports = __webpack_public_path__ + "img/bg_zbzr.8b6f9f27.png";